import * as table from './TableData'
import { CurrentTime, GET_COMPANY_FROM_URL, currentDate_dmy, loginUserDetails } from "../../../components/Common/CommonFunction";
import Image from '../../../assets/images/cbm_logo.png';

export const pageBorder = (doc) => {
    doc.setDrawColor('black');
    doc.line(570, 17, 30, 17);   // Top
    doc.line(30, 815, 30, 17);   // Left
    doc.line(570, 815, 570, 17); // Right
    doc.line(570, 815, 30, 815); // Bottom
};

export const pageHeder = (doc, data) => {
    //     doc.addFont("Arial", 'Normal');
    //     doc.setFont('Arial');
    //     doc.setFontSize(16);
    //         try {
    //         // ✅ Add your image to top-left of page
    //         doc.addImage(Image, "PNG", 40, 17, 45, 35, null, "FAST");
    //     } catch (e) {
    //         console.warn("Header image not found or invalid", e);
    //     }
    //    doc.text('Rate List Report', 255, 40); // Report Title


    const logo = localStorage.getItem(
        `${GET_COMPANY_FROM_URL()}_CompanyLogo`
    );

    doc.addFont("Arial", 'Normal');
    doc.setFont('Arial');

    doc.setFontSize(16);

    try {

        if (logo) {
            doc.addImage(logo, "PNG", 40, 17, 45, 35, null, "FAST");
        }

    } catch (e) {
        console.warn("Header image not found or invalid", e);
    }

    doc.text('Rate List Report', 255, 40);


};

export const reportHeder1 = (doc, data) => {
    doc.setFont('Tahoma');
    doc.setFontSize(11);
    doc.setFont(undefined, 'bold');


    const options3 = {
        didDrawCell: (data1) => {
            const rowIdx = data1.row.index;
            const colIdx = data1.column.index;
            if (rowIdx === 0 && colIdx === 0) {
                let x = data1.cursor.x + 2;
                let y = data1.cursor.y + 10;
                doc.setFontSize(9);
                doc.setFont(undefined, 'bold');
                doc.text('', x, y);
            }
        },
        margin: { top: 0, left: 30, right: 35 },
        theme: 'grid',
        styles: { overflow: 'linebreak', fontSize: 8, fillColor: [255, 255, 255] },
        bodyStyles: {
            columnWidth: 'wrap',
            textColor: [30, 30, 30],
            cellPadding: 3,
            fontSize: 9,
            lineColor: [0, 0, 0]
        },
        columnStyles: {
            0: { valign: "top", columnWidth: 540, halign: 'left' },
        },
        tableLineColor: "black",
        startY: 36
    };

    doc.autoTable(table.PageHedercolumns, table.ReportHederRows(data), options3);
};

export const tableBody = (doc, data) => {
    const options = {
        margin: { left: 30, right: 25, top: 55, bottom: 22 },
        theme: 'grid',
        headerStyles: {
            cellPadding: 4,
            lineWidth: 1,
            valign: 'top',
            fontStyle: 'bold',
            halign: 'center',
            fillColor: "white",
            textColor: [0, 0, 0],
            fontSize: 8,
            lineColor: [0, 0, 0],
        },
        bodyStyles: {
            textColor: [30, 30, 30],
            cellPadding: 3,
            fontSize: 7,
            columnWidth: 'wrap',
            lineColor: [0, 0, 0],
        },
        columnStyles: {
            0: { columnWidth: 200, halign: 'left' },   // Item Name
            1: { columnWidth: 80, halign: 'right' },  // Rate
            2: { columnWidth: 50, halign: 'left' }, // UOM
            3: { columnWidth: 80, halign: 'left' }, // GST Type
            4: { columnWidth: 130, halign: 'right' },  // GST
        },
        tableLineColor: "black",
        startY: doc.autoTableEndPosY(),
    };

    doc.autoTable(table.columns, table.Rows(data), options);
};

export const pageFooter = (doc, data) => {
    const pageCount = doc.internal.getNumberOfPages();
    doc.setFont('helvetica', 'Normal');
    doc.setFontSize(8);

    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        pageHeder(doc, data);
        pageBorder(doc);
        doc.setFontSize(8);
        doc.text(`Page ${i} of ${pageCount}`, 531, 828);
        doc.text(`Print Date: ${currentDate_dmy} Time ${CurrentTime()}`, 30, 828);
    }
};
